const enum Dir {
  N,
  E,
  S,
  W,
}
export default Dir;
